const titleCase = strng => (strng ? strng[0].toUpperCase() + strng.toLowerCase().slice(1) : strng);

export default titleCase;
